import { Icon, Menu } from "antd";
import React, { Component } from "react";
import MenuItem from "../../models/menuItem";
import "./index.less";
// img
import FunctionIcon from "@/assets/image/head/functionmenu.svg";
import PortalLightIcon from "@/assets/image/head/portalmenu-light.svg";
import PortalIcon from "@/assets/image/head/portalmenu.svg";
import SubMenu from "antd/lib/menu/SubMenu";
import Matrix from "../matrix";
import { getMenuIcon } from "./menu-icon";
import AppService from "../app.service";

interface iProps {
  appName?: string;
  menuItems: MenuItem[];
  mode?: any;
}

const Api = new AppService();

interface iState {
  matrixModalVisible: boolean;
  selectedKey: string;
  portalUrl: string;
}

export default class UIMenu extends Component<iProps, iState> {
  state: iState = {
    matrixModalVisible: false,
    selectedKey: "",
    portalUrl: "",
  };

  initData = async () => {
    const data = await Api.getIndexNewUrl();

    this.setState({ portalUrl: data || "" });
  };

  componentDidMount() {
    this.initData();
    const selectedKey = this.findUrlByAppName();
    if (selectedKey) this.setState({ selectedKey });
  }

  componentDidUpdate(prevProps: iProps) {
    // 如果 appName 或 menuItems 变化，重新设置激活项
    if (
      prevProps.appName !== this.props.appName ||
      prevProps.menuItems !== this.props.menuItems
    ) {
      const selectedKey = this.findUrlByAppName();
      if (selectedKey !== this.state.selectedKey) {
        this.setState({ selectedKey });
      }
    }
  }

  onClick = ({ item, key, keyPath, domEvent }) => {
    const getCurrentMenu: (menuItem: MenuItem[]) => MenuItem | undefined = (
      menuItems,
    ) => {
      if (!menuItems?.length) return;

      let res: MenuItem | undefined;
      menuItems.forEach((item) => {
        if (item?.menuId === key) {
          res = item;
        }
        if (!res && item?.subMenus?.length) {
          res = getCurrentMenu(item?.subMenus);
        }
      });
      return res;
    };

    const currenMenu = getCurrentMenu(this.props.menuItems);

    // 更新高亮项
    this.setState({ selectedKey: key });

    if (currenMenu?.target === "_matrix" || currenMenu?.menuId === "-1") {
      this.setState({ matrixModalVisible: !this.state.matrixModalVisible });
    } else if (currenMenu?.url) {
      const url = ["-100001", "-2"].includes(currenMenu?.menuId)
        ? this.state.portalUrl
        : `//${currenMenu?.url}`;

      window.location.href = `${window.location.protocol}${url}`;
    }
  };

  findUrlByAppName = () => {
    let { appName, menuItems } = this.props;
    let menuId = "";
    for (let i in menuItems) {
      if (menuItems[i].appName === appName) {
        menuId = menuItems[i]?.menuId;
        break;
      }
    }
    return menuId;
  };

  render() {
    let { menuItems, mode } = this.props;

    return (
      <>
        <Menu
          style={{
            flexGrow: 1,
            flexShrink: 0,
            height: "44px",
            lineHeight: "44px",
            color: mode === "dark" ? "#d7d7d7" : "#252525",
          }}
          className={mode === "dark" ? "topMenu" : "light-menu"}
          theme={mode}
          mode="horizontal"
          onClick={this.onClick}
          selectedKeys={this.state.selectedKey ? [this.state.selectedKey] : []}
        >
          {!!menuItems?.length &&
            menuItems.map((menuItem, index) =>
              !!menuItem?.subMenus?.length ? (
                <SubMenu
                  key={menuItem.menuId}
                  title={
                    <div>
                      {menuItem?.name}
                      <Icon style={{ marginRight: 0 }} type="down" />
                    </div>
                  }
                >
                  {menuItem?.subMenus?.map((subMenu, index) => (
                    <Menu.Item key={subMenu?.menuId}>
                      {subMenu?.name || "-"}
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={menuItem.menuId}>
                  {mode === "dark" ? (
                    <div className="topItem">
                      <div style={{ height: "46px" }}>
                        {menuItem.menuId === "-2" && (
                          <img
                            src={mode === "dark" ? PortalIcon : PortalLightIcon}
                            width="14"
                            height="14"
                            style={{
                              marginRight: "4px",
                              display: "inline-block",
                            }}
                          />
                        )}
                        {menuItem.menuId === "-1" && (
                          <img
                            src={FunctionIcon}
                            width="14"
                            height="14"
                            style={{
                              marginRight: "4px",
                              display: "inline-block",
                            }}
                          />
                        )}
                      </div>
                      <div className="topItem_text">
                        {menuItem?.name ?? "-"}
                      </div>
                    </div>
                  ) : (
                    <div className="topItem">
                      {getMenuIcon(menuItem.menuId)}
                      <div className="topItem_text">
                        {menuItem?.name ?? "-"}
                      </div>
                    </div>
                  )}
                </Menu.Item>
              ),
            )}
        </Menu>
        <Matrix
          visible={this.state.matrixModalVisible}
          onCancel={() => this.setState({ matrixModalVisible: false })}
        />
      </>
    );
  }
}
